/* eslint-disable */

const getters = {
  isAuthenticated: state => state.authenticated,
  currentUser: state => state.user,
  currentUserId: (state) => {
    if (state.user) {
      return state.user.uid || state.user.id;
    }
    return null;
  },
  currentUserEmail: state => state.user.email,
  currentUserEmailVerified: state => state.user.emailVerified,
  currentUserPhoneNumber: state => state.user.phoneNumber,
  currentUserDisplayName: state => state.user.displayName,
  currentUserPhotoURL: state => state.user.photoURL,
  currentUserAuthProfile: state => ({
    uid: state.user.uid,
    email: state.user.email,
    emailVerified: state.user.emailVerified,
    phoneNumber: state.user.phoneNumber,
    displayName: state.user.displayName,
    photoURL: state.user.photoURL,
  }),
  currentUserProfile: state => state.userProfile,
  userList: state => state.users,
  user: state => state.user,
  userToken: state => state.userToken,
  userGuide: state => state.userGuide,
};

export default getters;
